<template>
    <div>
        <div v-if="$route.name === 'rubric'" class="directory flex-row">
            <div v-if="lang === 'ru'" @click="$router.push({ name: 'home' })" class="text">Главная</div>
            <div v-if="lang === 'kk'" @click="$router.push({ name: 'home' })" class="text">Басты бет</div>
            <svg width="6" height="9" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 6.5L3.5 3.5L0.5 0.5" stroke="#282F36" stroke-opacity="0.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: title, sub: subtitle } })" class="text">{{ titleRu }}</div>
            <div v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: title, sub: subtitle } })" class="text">{{ titleKz }}</div>
        </div>
        <div v-if="$route.name === 'article'" class="directory flex-row">
            <div v-if="lang === 'ru'" @click="$router.push({ name: 'home' })" class="text">Главная</div>
            <div v-if="lang === 'kk'" @click="$router.push({ name: 'home' })" class="text">Басты бет</div>
            <svg width="6" height="9" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 6.5L3.5 3.5L0.5 0.5" stroke="#282F36" stroke-opacity="0.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: title, sub: subtitle } })" class="text">{{ titleRu }}</div>
            <div v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: title, sub: subtitle } })" class="text">{{ titleKz }}</div>
            <!-- <svg width="6" height="9" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 6.5L3.5 3.5L0.5 0.5" stroke="#282F36" stroke-opacity="0.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> -->
            <!-- <div class="text">Переходный возраст:девочки</div> -->
        </div>
        <div v-if="$route.name !== 'rubric' && $route.name !== 'article'" class="directory flex-row">
            <div v-if="lang === 'ru'" @click="$router.push({ name: 'home' })" class="text">Главная</div>
            <div v-if="lang === 'kk'" @click="$router.push({ name: 'home' })" class="text">Басты бет</div>
            <svg width="6" height="9" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 6.5L3.5 3.5L0.5 0.5" stroke="#282F36" stroke-opacity="0.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div v-if="lang === 'ru'" @click="$router.push({ name: route.name })" class="text">{{ route.meta.title }}</div>
            <div v-if="lang === 'kk'" @click="$router.push({ name: route.name })" class="text">{{ route.meta.titleKz }}</div>
        </div>
    </div>
</template>
<script>
import json from '../common/en-ru.json'
import jsonKz from '../common/en-kz.json'
export default {
    props: ['route', 'title', 'subtitle'],
    data(){
        return {
            titleRu: '',
            titleKz: '',
            lang: 'kk'
        }
    },
    watch:{
        '$route' () {
            this.init()
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            if( localStorage.getItem('xyzCustomLang') ){
                this.lang = localStorage.getItem('xyzCustomLang')
            } 
            this.titleRu = json[this.subtitle]
            this.titleKz = jsonKz[this.subtitle]
        }
    }
}
</script>
<style lang="scss" scoped>
    .directory{
        margin-bottom: 30px;
        cursor: default;
        .text{
            cursor: pointer;
            font-weight: 300;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 1px;
            color: #000000;
        }
        svg{
            margin: 6px 9px auto 12px;
        }
        .text:last-of-type{
            color: #808080;
        }
    }
    @media only screen and (max-width: 1330px){
        .directory{
            margin-bottom: 20px;
            cursor: default;
            .text{
                cursor: pointer;
                font-weight: 300;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: 1px;
                color: #000000;
            }
            svg{
                margin: 6px 6px auto 9px;
            }
            .text:last-of-type{
                color: #808080;
            }
        }  
    }
    @media only screen and (max-width: 720px){
        .directory{
            margin-bottom: 20px;
            cursor: default;
            .text{
                cursor: pointer;
                font-weight: 300;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 1px;
                color: #000000;
            }
            svg{
                margin: 6px 6px auto 9px;
            }
            .text:last-of-type{
                color: #808080;
            }
        }  
    }
    @media only screen and (max-width: 480px){
        .directory{
            margin-bottom: 20px;
            cursor: default;
            .text{
                cursor: pointer;
                font-weight: 300;
                font-size: 12px;
                line-height: 20px;
                letter-spacing: 0.5px;
                color: #000000;
            }
            svg{
                margin: 6px 2px auto 4px;
            }
            .text:last-of-type{
                color: #808080;
            }
        }  
    }
</style>


